import { ApiResponse } from "../common/type";
import axiosClient from "./axiosClient";

const adminApi = {
    getAllBranch: async (params: { page: number; limit: number }): Promise<ApiResponse<any>> => {
    return axiosClient.get('/branch', {
        params,
    });
    },
    createBranch: async (data: any): Promise<ApiResponse<any>> => {
        return axiosClient.post('/branch', data);
    },
    updateBranch: async (id: number, data: any): Promise<ApiResponse<any>> => {
        return axiosClient.patch(`/branch/${id}`, data);
    },
    deleteBranch: async (id: number): Promise<ApiResponse<any>> => {
        return axiosClient.delete(`/branch/${id}`);
    },
    getAllCourse: async (params: { page: number; limit: number }): Promise<ApiResponse<any>> => {
        return axiosClient.get('/course', { params });
    },
    createCourse: async (data: any): Promise<ApiResponse<any>> => {
        return axiosClient.post('/course', data);
    },
    updateCourse: async (id: number, data: any): Promise<ApiResponse<any>> => {
        return axiosClient.patch(`/course/${id}`, data);
    },
    deleteCourse: async (id: number): Promise<ApiResponse<any>> => {
        return axiosClient.delete(`/course/${id}`);
    },
    getAllSubject: async (): Promise<ApiResponse<any>> => {
        return axiosClient.get('/subjects');
    },
    createSubject: async (data: any): Promise<ApiResponse<any>> => {
        return axiosClient.post('/subjects', data);
    },
    updateSubject: async (id: number, data: any): Promise<ApiResponse<any>> => {
        return axiosClient.patch(`/subjects/${id}`, data);
    },
    deleteSubject: async (id: number): Promise<ApiResponse<any>> => {
        return axiosClient.delete(`/subjects/${id}`);
    },
    getAllUser: async (params: any): Promise<ApiResponse<any>> => {
        return axiosClient.get('/admin/user', { params });
    },
     getAllAdmin: async (params: any): Promise<ApiResponse<any>> => {
        return axiosClient.get('/admin', { params });
    },
    createAdmin: async (data: any): Promise<ApiResponse<any>> => {
        return axiosClient.post('/admin', data);
    },
};

export default adminApi;
